import React, { createContext, useContext, useState, useEffect } from "react";
import { getRequest } from "../Api/ApiCall";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState({});
  const [accessToken, setAccessToken] = useState(null);
  const [liveApps, setLiveApps] = useState([]);
  const [betaApps, setBetaApps] = useState([]);
  const [requests, setRequests] = useState([]);
  const [loadingStates, setLoadingStates] = useState({});

  const setLoading = (key, value) => {
    setLoadingStates((prev) => ({ ...prev, [key]: value }));
  };

  const fetchRequests = async () => {
    if (!user.email) return;
    setLoading("fetchRequests", true);
    try {
      const data = await getRequest("/request/all", { emailId: user.email });
      if (data.status) {
        setRequests(data.data);
      } else {
        console.error("Failed to fetch requests");
      }
    } catch (err) {
      console.error("Error fetching data", err);
    } finally {
      setLoading("fetchRequests", false);
    }
  };

  const fetchApps = async () => {
    if (!user.email) return;
    setLoading("fetchApps", true);
    try {
      const response = await getRequest(`/application/all?emailId=${encodeURIComponent(user.email)}`);
      if (response.status) {
        const live = response.data?.live || [];
        const beta = response.data?.beta || [];
  
        setLiveApps(live);
        setBetaApps(beta);
      } else {
        console.error("Failed to fetch apps: Invalid data.");
      }
    } catch (error) {
      console.error("Error fetching apps:", error);
    } finally {
      setLoading("fetchApps", false);
    }
  };

  useEffect(() => {
    if (!user?.email) return; 
    fetchRequests();
    fetchApps();
  }, [user]);
  

  return (
    <AuthContext.Provider value={{ user, setUser, liveApps, betaApps, setLiveApps, setBetaApps, accessToken, setAccessToken, requests, setRequests, loadingStates ,fetchApps,fetchRequests}}>
      {children}
    </AuthContext.Provider>
  );
}
